import {Button, Dropdown, Menu} from "antd";
import {UserOutlined, ZhihuOutlined} from "@ant-design/icons";
import {LocalStorageService} from "../core/service/LocalStorageService";
import {t} from "i18next";
import PatientLocalStorage from "./PatientLocalStorage";
import {useHistory} from "react-router-dom";
import {useEffect} from "react";
import ApiService from "../core/service/ApiService";

const {SubMenu} = Menu;
export default function PatientDropdown() {
    const history = useHistory();

    const logout = () => {
        PatientLocalStorage.logout()
        window.location.reload()
    }

    const onClick = (item) => {
        if(item.key === 'logout')
        {
            logout()
        }
        else if(['en', 'tr'].includes(item.key))
        {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
    }

    const menu = (
        <Menu onClick={onClick}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={t('Language')}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="logout" icon={<UserOutlined />}>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    useEffect(() => {
        ApiService.setLogout(logout)
    }, [])

    return (
        <Dropdown overlay={menu} placement="bottomCenter" icon={<UserOutlined />}>
            <Button>
                <UserOutlined />
                {PatientLocalStorage.getInformation()?.name ?? 'NAME'}
            </Button>
        </Dropdown>
    )
}